import { render, staticRenderFns } from "./DaoMembersView.vue?vue&type=template&id=180a5408&scoped=true&"
import script from "./DaoMembersView.vue?vue&type=script&lang=js&"
export * from "./DaoMembersView.vue?vue&type=script&lang=js&"
import style0 from "./DaoMembersView.vue?vue&type=style&index=0&id=180a5408&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180a5408",
  null
  
)

export default component.exports